/** @format */

import request from 'src/utils/request'

// 获取场景列表
export const getSceneList = async params => {
  const result = await request('/oos/?Action=ListScene&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result?.data?.Data || { Info: [], Total: 0 }
}

// 获取场景详情
export const getScene = async (ID: string | number, editable?: boolean) => {
  const result = await request('/oos/?Action=GetScene&Version=2025-01-01', {
    data: { ID, Latest: editable },
    method: 'GET'
  })
  return result?.data?.Data
}

// 删除
export const deleteScene = async data => {
  const result = await request('/oos/?Action=DeleteScene&Version=2025-01-01', {
    data,
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}

// 执行场景
export const launchScene = async data => {
  const result = await request('/oos/?Action=LaunchScene&Version=2025-01-01', {
    data,
    method: 'POST'
  })
  return result?.data?.Code === 'success' ? result?.data?.Data : false
}

// 保存场景
export const saveScene = async data => {
  const result = await request('/oos/?Action=SaveScene&Version=2025-01-01', {
    data,
    method: 'POST'
  })
  return result?.data?.Code === 'success' ? result?.data?.Data : false
}

// 预发布场景（测试使用）
export const activateScene = async data => {
  const result = await request('/oos/?Action=ActivateScene&Version=2025-01-01', {
    data,
    method: 'POST'
  })
  return result?.data?.Code === 'success' ? result?.data?.Data : false
}
